module.exports = __webpack_public_path__ + "static/img/home_background.fe8c9af9.webp";